import { Skeleton } from '@mui/material';
import { NavLink } from 'react-router-dom';
import Logo from '../../Assets/KnowRisk_Inline_Dark_RGB.svg';
import '../Header/Header.css';
import './AuthScaffolding.css';

export default function AuthScaffolding() {
  return (
    <>
      <header>
        <NavLink to="/">
          <img className="logo" src={Logo} alt="KnowRisk Logo" />
        </NavLink>
        <div style={{ flexGrow: 1 }} />
        <Skeleton variant="circular" width={32} height={32} />
      </header>
      <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
        <aside id="menu" className="scaffolding-sidebar">
          <ul>
            <li className="nav-header-item">
              <Skeleton variant="text" width={140} height={35} style={{ marginLeft: 20 }} />
            </li>
            {[...Array(5)].map((_, i) => (
              <li className="nav-item" key={i}>
                <Skeleton variant="text" width={120} height={28} style={{ marginLeft: 20 }} />
              </li>
            ))}
            <li className="nav-header-item">
              <Skeleton variant="text" width={80} height={35} style={{ marginLeft: 20 }} />
            </li>
            {[...Array(3)].map((_, i) => (
              <li className="nav-item" key={`tools-${i}`}>
                <Skeleton variant="text" width={100} height={28} style={{ marginLeft: 20 }} />
              </li>
            ))}
          </ul>
        </aside>
        <main>
          <div className="main-outlet" />
        </main>
      </div>
    </>
  );
}
